function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h9v3H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d52b1e",
  d: "M0 3h9v3H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0039a6",
  d: "M0 2h9v2H0z"
});

function SvgRu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 6"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5IDYiPgo8cmVjdCBmaWxsPSIjZmZmIiB3aWR0aD0iOSIgaGVpZ2h0PSIzIi8+CjxyZWN0IGZpbGw9IiNkNTJiMWUiIHk9IjMiIHdpZHRoPSI5IiBoZWlnaHQ9IjMiLz4KPHJlY3QgZmlsbD0iIzAwMzlhNiIgeT0iMiIgd2lkdGg9IjkiIGhlaWdodD0iMiIvPgo8L3N2Zz4K";
export { SvgRu as ReactComponent };